// extracted by mini-css-extract-plugin
module.exports = {"container":"SwitchLanguageComponent_container__o81lK","button":"SwitchLanguageComponent_button__ZJbPE"};